<template><div><h1 id="filter-markieren" tabindex="-1"><a class="header-anchor" href="#filter-markieren"><span>Filter markieren</span></a></h1>
<p>Filter markieren — Markieren von Personen mit Filtern</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Dieser Job interpretiert die Filterparameter und trägt die Person mit der entsprechenden Filternummer in die Filterdatenbank ein. Die Markierung ist Bedingung für die Nutzung des Filters.</p>
<h2 id="start-parameter" tabindex="-1"><a class="header-anchor" href="#start-parameter"><span>Start &amp; Parameter</span></a></h2>
<p>Pfad: Personen → Filter → Kontextmenu → Markieren...</p>
<p><strong>Parameter</strong></p>
<dl>
<dt>Filter</dt>
<dd>Filter, der markiert werden soll (Vorschlag des selektierten Filters)</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Es gibt kein Output.</p>
<h2 id="welche-daten-werden-verwendet-input" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verwendet-input"><span>Welche Daten werden verwendet? (Input)</span></a></h2>
<p>Je nach Filterdefinition können es verschiedene Daten sein. Im obigen Beispiel sind es die Personendaten.</p>
<h2 id="welche-daten-werden-verandert-oder-erzeugt" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verandert-oder-erzeugt"><span>Welche Daten werden verändert oder erzeugt?</span></a></h2>
<p>Die Filtermarkierung wird geschrieben oder überschrieben.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.adrfilter.html#Filter" title="Beschreibung">Filter erfassen, ändern</RouteLink></p>
</div></template>


